/**
 * Static Starter - Main JavaScript File
 * Modern jQuery + Bootstrap 5 functionality
 */

import { scrollAnimations } from './scroll-animations.js';
import { header } from './header.js';
import { megamenu } from './megamenu.js';
import { mobileMenu } from './mobile-menu.js';
import { accordionPromo } from './accordion-promo.js';
import { carousels } from './carousel.js';
import { ui } from './ui.js';
import { login } from './login.js';
import { socialShare } from './social-share.js';
import { compareTable } from './compare-table.js';
import { customTabs } from './custom-tabs.js';
import { lightbox } from './lightbox.js';
import { videoLightbox } from './video-lightbox.js';
import { articleFilter } from './article-filter.js';
import { faqsFilter } from './faqs-filter.js';
import { searchResults } from './search-results.js';
import { equalizeHeights } from './equalize-heights.js';
import { initSpeedbump } from './speedbump.js';
import { mloSearch } from './mlo-search.js';
import { clipboardCopy } from './clipboard-copy.js';
import { addToCalendar } from './add-to-calendar.js';
import { skipLinks } from './skip-links.js';
import { disclosures } from './disclosures.js';
import { searchDropdown } from './search-dropdown.js';
import { ketchPrefs } from './ketch.js'
import { liveChat } from './livechat.js';
import { anchorLinks } from './anchor-links.js';
import { appDownloadLinks } from './app-download.js';
import { footer } from './footer.js';

//Branch locator - defines window.initLocatorMap for the Google Maps callback
import './locator.js';

//Web Components
import './web-components/wa-select.js';
import './web-components/wa-multi-select.js';
import './web-components/wa-scrollbar.js';
import './web-components/wa-app-download.js';

$(document).ready(function() {
    'use strict';
    
    // Initialize modules
    header();
    mobileMenu();
    scrollAnimations();
    megamenu(); 
    accordionPromo();
    carousels();
    ui();
    login();
    socialShare();
    compareTable();
    customTabs();
    lightbox();
    videoLightbox();
    articleFilter();
    faqsFilter();
    searchResults();
    equalizeHeights();
    initSpeedbump();
    mloSearch();
    clipboardCopy();
    addToCalendar();
    skipLinks();
    disclosures();
    searchDropdown();
    ketchPrefs();
    liveChat();
    anchorLinks();
    appDownloadLinks();
    footer();
});


// jQuery easing extension for smooth scrolling
$.extend($.easing, {
    easeInOutCubic: function(x, t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t * t + b;
        return c / 2 * ((t -= 2) * t * t + 2) + b;
    }
});


